import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Store } from 'src/app/core/store/store';
import { PlayerUtilityService } from 'src/app/modules/player/services/player-utility.service';
import { HandleSubscription } from '../../utils/handle-subscription';

declare var bodymovin;

@Component({
  selector: 'app-common-feedback',
  templateUrl: './common-feedback.component.html',
  styleUrls: ['./common-feedback.component.scss']
})
export class CommonFeedbackComponent extends HandleSubscription implements OnInit {
  feedbackForm: FormGroup;
  // programActivationId: any;
  courseId: any;
  starSelected;
  stars: number[] = [1, 2, 3, 4, 5];
  tagsCourses: string[] = ['Course Videos', 'Faculty Videos', 'Practice Now', 'Touchstone', 'Navigation'];
  // tagsCourses: string[] = ['Course Assessments', 'Course Videos', 'Course Navigation'];
  tagsMasterclass: string[] = ['Masterclass Content', 'Faculty', 'Navigation', 'Overall Experience'];

  tagValue = [];
  @Output() hideFeedback = new EventEmitter<boolean>();
  @Input() user;
  currentUserCourse: any;
  @Input() completedItemObj: any;
  @Input() programActivationId;
  constructor(private fb: FormBuilder, private playerService: PlayerUtilityService, private store: Store) {
    super();
  }

  ngOnInit() {

    console.log('common called', this.completedItemObj);


    this.store.select('currentUserCourse').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      if(data) {
        this.programActivationId = data.programActivationId;
        this.courseId = data.courseId;
        this.currentUserCourse = data;
      }
    });
    this.createForm();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.addAnimation(
        "buttonThree",
        "thirdAnimation",
        "https://assets2.lottiefiles.com/packages/lf20_pkanqwys.json"
    );
    }, 1000);
  }

  createForm() {
    this.feedbackForm = this.fb.group({
      wordsAndTags: [null],
      text: [null],
      rating: null
    })
  }

  saveFeedback() {
    let data = {
      programActivationId: this.programActivationId,
      courseId: this.completedItemObj.courseId ? this.completedItemObj.courseId : null,
      masterClassObjectId: this.completedItemObj.masterClassObjects && this.completedItemObj.masterClassObjects.length > 0 && this.completedItemObj.masterClassObjects[0]._id ? this.completedItemObj.masterClassObjects[0]._id : null,
      feedback: {
        wordsAndTags: this.feedbackForm.value.wordsAndTags,
        text: this.feedbackForm.value.text,
        rating: this.feedbackForm.value.rating
      }
    }
    this.playerService.saveFeedback(data).subscribe(
      (res) => {
        if(res) {
          this.hideFeedback.emit(false);
        }
      },(error) => {
        console.log(error);
      }
    )
  }

  startClicked(num) {
    if(num) {
      this.starSelected = num;
      this.feedbackForm.get('rating').patchValue(num);
    }
  }

  courseTagSelected(i: number) {
    let selectedIndex = this.tagValue.indexOf(this.tagsCourses[i]);
    if( selectedIndex != -1) {
      this.tagValue.splice(selectedIndex, 1);
    } else {
      this.tagValue.push(this.tagsCourses[i]);
      this.feedbackForm.get('wordsAndTags').patchValue(this.tagValue.toString());
    }

  }

  masterclassTagSelected(i: number) {
    let selectedIndex = this.tagValue.indexOf(this.tagsMasterclass[i]);
    if( selectedIndex != -1) {
      this.tagValue.splice(selectedIndex, 1);
    } else {
      this.tagValue.push(this.tagsMasterclass[i]);
      this.feedbackForm.get('wordsAndTags').patchValue(this.tagValue.toString());
    }

  }

  addAnimation(buttonNumber, animationNumber, path) {
    // const buttonX = document.getElementById(buttonNumber);
    const XAnimation = document.getElementById(animationNumber);

    const animItemX = bodymovin.loadAnimation({
      wrapper: XAnimation,
      animType: "svg",
      loop: false,
      autoplay: false,
      path: path,
    });

    // buttonX.addEventListener("click", () => {

    // });
    XAnimation.classList.remove("hide");
    animItemX.goToAndPlay(0, true);
    animItemX.addEventListener("complete", () => {
      XAnimation.classList.add("hide");
    });
  }

  protected readonly JSON = JSON;
}
